/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class FormService extends warsApp.services.DataService<Wars.Domain.Model.Form> {

        private logType: string = "FormService";

        constructor(
            injectedBreeze: typeof breeze,
            $q: angular.IQService,
            private $http: angular.IHttpService,
            private modalService: any,
            private formSectionService: services.FormSectionService,
            private securityMatrixService:services.SecurityMatrixService,
            private dataSourceService:services.DataSourceService) {
            super(injectedBreeze, $q);
        }

        public createForm(processConfiguration?: Wars.Domain.Model.ProcessConfiguration): Wars.Domain.Model.Form {
            var form = this.createNewEntity<Wars.Domain.Model.Form>("Form", { MyProcessConfiguration: processConfiguration });
            form.uniqueIdentifier = UtilityService.generateGuidComb();
            return form;
        }

        public createFormStep(form: Wars.Domain.Model.Form): Wars.Domain.Model.FormStep {
            return this.createNewEntity<Wars.Domain.Model.FormStep>("FormStep", { myForm: form });
        }
        public createUrl(form: Wars.Domain.Model.Form): Wars.Domain.Model.UrlDependency {
            return this.createNewEntity<Wars.Domain.Model.UrlDependency>("UrlDependency", {form: form});
        }

        public createFormSection(step: Wars.Domain.Model.FormStep): models.FormSection {
            return this.createNewEntity<models.FormSection>("FormSection", { step: step });
        }


        public createManageSection(): Wars.Domain.Model.ManageSection {
            let manageSection = this.createNewEntity<Wars.Domain.Model.ManageSection>("ManageSection");
            manageSection.uniqueIdentifier = UtilityService.generateGuidComb();
            return manageSection;
        }

        public createManageStatusConfiguration(): Wars.Domain.Model.ManageStatusConfiguration {
            return this.createNewEntity<Wars.Domain.Model.ManageStatusConfiguration>("ManageStatusConfiguration");
        }

        public createManageTimeTrackerConfiguration(): Wars.Domain.Model.ManageTimeTrackerConfiguration {
            return this.createNewEntity<Wars.Domain.Model.ManageTimeTrackerConfiguration>("ManageTimeTrackerConfiguration");
        }

        public createCommentThreadConfiguration(): Wars.Domain.Model.CommentThreadConfiguration{
            let commentThreadConfiguration = this.createNewEntity<Wars.Domain.Model.CommentThreadConfiguration>("CommentThreadConfiguration");

            commentThreadConfiguration.uniqueIdentifier = services.UtilityService.generateGuidComb();
            commentThreadConfiguration.canDeleteComments = false;
            commentThreadConfiguration.canDeleteOwnComment = false;
            commentThreadConfiguration.deleteLabel = "Delete";
            commentThreadConfiguration.maxLevelsOfDepth = 3;
            commentThreadConfiguration.showAvatar = true;
            commentThreadConfiguration.allowCommentDateToBeSet = false;
            commentThreadConfiguration.allowDocuments = false;
            commentThreadConfiguration.commentDateLabel = "Comment Date";


            commentThreadConfiguration.canCommentSecurityMatrix = this.securityMatrixService.createSecurityMatrix(false, false);
            commentThreadConfiguration.canDeleteSecurityMatrix = this.securityMatrixService.createSecurityMatrix(false, false);
            commentThreadConfiguration.canViewDeletedCommentsSecurityMatrix = this.securityMatrixService.createSecurityMatrix(false, false);

            return commentThreadConfiguration;
        }

        public createManageDocumentConfiguration(): Wars.Domain.Model.ManageDocumentsConfiguration {
            var newConfig = this.createNewEntity<Wars.Domain.Model.ManageDocumentsConfiguration>("ManageDocumentsConfiguration");
            newConfig.uniqueIdentifier = UtilityService.generateGuidComb();
            newConfig.canUploadDocuments = false;
            newConfig.canSelectDocuments = false;
            newConfig.canSelectSecureDocuments = false;
            newConfig.canEditIsSecureValue = false;
            newConfig.includeFieldDocuments = false;
            newConfig.includeReviewDocuments = false;
            newConfig.includeUserActionDocuments = false;
            newConfig.includeManageDocumentSectionDocuments = false;
            newConfig.includeProcessEventSectionDocuments = false;
            newConfig.includeCommentThreadSectionDocuments = false;
            newConfig.includeSecuredDocumentColumn = false;
            newConfig.includeSecuredDocuments = false;
            return newConfig;
        }

        public createFormGridColumn(formSection: Wars.Domain.Model.FormSection): Wars.Domain.Model.FormGridColumn {
            return this.createNewEntity<Wars.Domain.Model.FormGridColumn>("FormGridColumn", { formSection: formSection });
        }

        public createCondition(field: Wars.Domain.Model.Field): models.Condition {
            var condition = this.createNewEntity<models.Condition>("Condition", { field: field });
            condition.expression = this.createNewEntity<Wars.Domain.Model.Conditions.GroupExpression>("GroupExpression");
            services.WarsLogger.logDebug("Create Condition", this.logType, condition);
            return condition;
        }

        public createField(formSection: models.FormSection): Wars.Domain.Model.Field {
            var newField = this.createNewEntity<Wars.Domain.Model.Field>("Field", { formSection: formSection, excludeFromSaves: false });
            newField.applySecurityMatrix = false;
            newField.applyDefaultValueSecurityMatrix = false;
            newField.showLinkForAutoComplete = false;
            newField.isRequired = false;
            newField.disallowEmptyValue = false;
            return newField;
        }

        public createNewCondition(): models.Condition {
            var condition = this.createNewEntity<models.Condition>("Condition");
            condition.expression = this.createGroupExpression();
            console.info(condition);
            return condition;
        }

        public createGroupExpression(): Wars.Domain.Model.Conditions.GroupExpression {
            var exp = this.createNewEntity<Wars.Domain.Model.Conditions.GroupExpression>("GroupExpression");
            exp.expressionType = Wars.Domain.Model.Codes.Enums.ExpressionType.Group;

            return exp;
        }

        public getById(id: string): ng.IPromise<Wars.Domain.Model.Form> {
            const query = this.breezeModule.EntityQuery
                .from("Forms")
                .where("id", "==", id);

            return this.fetch(query);
        }

        public getManageFormConfiguration(id: string): ng.IPromise<Wars.Domain.Model.Form> {
            var p1 = new breeze.Predicate("id", "==", id);
            var expand =
                "myManageSections.manageProcessDataConfiguration.processDataViewConfigurations, " +
                    "myManageSections.manageStatusConfiguration.securityMatrixForRespondingToComments, " +
                    "myManageSections.apiGridConfiguration.columns, " +
                    "myManageSections.manageClockConfigurations.securityMatrix, " +
                    "myManageSections.assignmentConfiguration.assignmentSectionClaims.claimDefinition, " +
                    "myManageSections.commentThreadConfiguration.documentConfiguration.canDownloadSecureDocumentSecurityMatrix, " +
                    "myManageSections.commentThreadConfiguration.documentConfiguration.canSecureDocumentSecurityMatrix, " +
                    "myManageSections.commentThreadConfiguration.documentConfiguration.myAvailableDocumentTypes.mySystemCode, " + 
                    "myManageSections.commentThreadConfiguration.canCommentSecurityMatrix, " +
                    "myManageSections.commentThreadConfiguration.canDeleteSecurityMatrix, " +
                    "myManageSections.commentThreadConfiguration.canViewDeletedCommentsSecurityMatrix, " + 
                    "myManageSections.commentThreadConfiguration.reviewConfiguration, " +
                    "myManageSections.commentThreadConfiguration.commentEmailConfiguration, " +
                    "myManageSections.securityMatrix, " +
                    "myManageSections.manageDocumentsConfiguration.canUploadDocumentsSecurityMatrix, " +
                    "myManageSections.manageDocumentsConfiguration.canSelectDocumentsSecurityMatrix, " +
                    "myManageSections.manageDocumentsConfiguration.canSelectSecureDocumentsSecurityMatrix, " +
                    "myManageSections.manageDocumentsConfiguration.canEditIsSecureValueSecurityMatrix, " +
                    "myManageSections.manageDocumentsConfiguration.documentConfiguration.canDownloadSecureDocumentSecurityMatrix, " +
                    "myManageSections.manageDocumentsConfiguration.documentConfiguration.canSecureDocumentSecurityMatrix, " +
                    "myManageSections.manageProcessEventConfiguration.manageProcessEventConfigResos, " +
                    "formSchema.properties, " +
                    "urlDependencies, " +
                    "securityMatrix.claimBindings";

            const query = this.breezeModule.EntityQuery
                .from("FormsLazy")
                .where(p1)
                .expand(expand);

            return this.fetch(query);
        }

        public getFormFields(processConfigurationId: string, variableType?: number): ng.IPromise<Wars.Domain.Model.Field[]> {
            var deferred = this.$q.defer();


            const query = this.breezeModule.EntityQuery
                .from("Forms")
                .where("processConfiguration_id", "==", processConfigurationId)
                .expand("mySteps.formSections.fields.schemaProperty, mySteps.formSections.objectSchema");

            this.executeQuery(query).then((forms) => {
                var allFields = Enumerable.from(forms)
                    .selectMany(i => i.mySteps)
                    .selectMany(i => i.formSections)
                    .selectMany(i => i.fields)
                    .toArray();

                if (variableType === undefined || variableType === null) {
                    deferred.resolve(allFields);
                } else {
                    var filteredSet = Enumerable.from(allFields)
                        .where(i => i.schemaProperty.propertyType === variableType)
                        .toArray();

                    deferred.resolve(filteredSet);
                }
            });

            return deferred.promise;
        }

        public getFormConfiguration(id: string): ng.IPromise<Wars.Domain.Model.Form> {
            var p1 = new breeze.Predicate("id", "==", id);
            var expand =
                "mySteps.formCodeFunctions, " +
                "mySteps.formSections.securityMatrix, " +
                "mySteps.formSections.fields.schemaProperty.codeGroup.codes, " +
                "formSchema.properties, " +
                "mySteps.formSections.columns.schemaProperty, " +
                "mySteps.formSections.systemLevelListSchemaProperty.typeSchema, " +
                "mySteps.formSections.fields.staticDocument, " +
                "mySteps.formSections.fields.gisActionWorkflowOverride.gisActionWorkflowConfiguration.gisActionBlocks, " +
                "mySteps.formSections.fields.mapConfigurationOverride.mapConfiguration.layers, " +
                "mySteps.formSections.fields.mapConfigurationOverride.mapConfiguration.legendConfigurations.legendLayers, " +
                "mySteps.formSections.fields.fieldExcludedStatuses.statusCode, " +
                "mySteps.formSections.fields.fieldExcludedSystemCodes.systemCode, " +
                "mySteps.formSections.fields.fieldExcludedStates.stateCode, " +
                "mySteps.formSections.fields.fieldExcludedProcessTypes.processType, " +
                "mySteps.formSections.fields.securityMatrix, " +
                "mySteps.formSections.fields.schemaProperty.scheduledResourceConfiguration, " +
                "mySteps.formSections.fields.schemaProperty.documentConfiguration.canDownloadSecureDocumentSecurityMatrix, " +
                "mySteps.formSections.fields.schemaProperty.documentConfiguration.canSecureDocumentSecurityMatrix, " +
                "mySteps.formSections.fields.schemaProperty.documentConfiguration.myAvailableDocumentTypes.mySystemCode, " +
                "mySteps.formSections.fields.apiGridConfiguration.columns, " +
                "mySteps.formSections.fields.includedMapFunction.mapFunctionConfiguration, " +
                "mySteps.formSections.fields.queryGridOverride.queryGridConfiguration, " +
                "mySteps.objectSchema.properties, " +
                "urlDependencies, " +
                "mySteps.formSections.objectSchema.properties, " +
                "securityMatrix.claimBindings";

            const query = this.breezeModule.EntityQuery
                .from("FormsLazy")
                .where(p1)
                .expand(expand);

            return this.fetch(query);
        }

        public getProcessConfigurationForms(processConfigurationId: string): ng.IPromise<Wars.Domain.Model.Form[]> {
            const query = this.breezeModule.EntityQuery
                .from("Forms")
                .where("processConfiguration_id", "==", processConfigurationId);

            return <any>(this.executeQuery(query));
        }

        public getProcessConfigurationContainers(processConfigurationId: string): ng.IPromise<Wars.Domain.Model.Form[]> {
            const query = this.breezeModule.EntityQuery
                .from("FormContainers")
                .where("processConfiguration_id", "==", processConfigurationId);

            return <any>(this.executeQuery(query));
        }

        public getProcessConfigurationFormsWithSections(processConfigurationId: string): ng.IPromise<Wars.Domain.Model.Form[]> {
            const query = this.breezeModule.EntityQuery
                .from("Forms")
                .where("processConfiguration_id", "==", processConfigurationId)
                .expand("myManageSections, mySteps.formSections.objectSchema, mySteps.formSections.fields.schemaProperty");

            return <any>(this.executeQuery(query));
        }

        public getSystemForms(): ng.IPromise<Wars.Domain.Model.Form[]> {
            const query = this.breezeModule.EntityQuery
                .from("Forms")
                .where("processConfiguration_id", "==", null);

            return <any>(this.executeQuery(query));
        }

        public getDynamicForms(): ng.IPromise<Wars.Domain.Model.Form[]> {
            const query = this.breezeModule.EntityQuery.from("DynamicFormCustom");
            return <any>(this.executeQuery(query));
        }

        public loadFieldGroup(field: Wars.Domain.Model.Field) {
            const query = this.breezeModule.EntityQuery
                .from("Fields")
                .where('id', '==', field.id)
                .expand('schemaProperty.codeGroup.codes');

            this.executeQuery(query);
        }

        public setFieldPropertySchemaParent(step: Wars.Domain.Model.FormStep, formSection: Wars.Domain.Model.FormSection,
            property: Wars.Domain.Model.SchemaProperty, formConfiguration: Wars.Domain.Model.Form) {
            if (formSection.isVisible) {
                property.parentObjectSchema = formSection.objectSchema;
                formSection.objectSchema.properties.push(property);
            }
            else if (formConfiguration.mySteps.length > 1) {
                property.parentObjectSchema = step.objectSchema;
                step.objectSchema.properties.push(property);
            }
            else {
                formConfiguration.formSchema.properties.push(property);
            }
        }

        public deleteFormSection(formSection: Wars.Domain.Model.FormSection, step: Wars.Domain.Model.FormStep) {
            var fields = formSection.fields;

            for (var i = 0; i < fields.length; i++) {
                fields[i].entityAspect.setDeleted();
            }

            this.saveAllChanges(s => {
                formSection.entityAspect.setDeleted();
                this.saveAllChanges();
            });

            step.formSections.remove(formSection);
        }

        public editField(field: Wars.Domain.Model.Field, formSection: Wars.Domain.Model.FormSection,
            processConfiguration: Wars.Domain.Model.ProcessConfiguration, form: Wars.Domain.Model.Form) {
            var self = this;
            //console.log(processConfiguration);

            (<any>field).fieldTypeChanged = false;

            this.modalService.showModal({
                templateUrl: "./app/views/editField.html",
                controller: "editFieldController",
                size: 'lg',
                inputs: {
                    field: field,
                    processConfigurationId: processConfiguration.id,
                    formSection: formSection,
                    processConfiguration: processConfiguration,
                    form: form
                }
            }).then(modal => {
                modal.element.modal();

                modal.close.then(result => {
                    $('.modal-backdrop').each(function () {
                        $(this).remove();
                    });

                    if (result) {
                        self.saveAllChanges();
                        field["refresh"] = true;
                        self.formSectionService.splitFields(<any>formSection);
                        if ((<any>field).fieldTypeChanged) {
                            this.updateFieldType(field.schemaProperty_id, field.schemaProperty.propertyType);
                        }

                    } else {
                        self.rejectChanges();
                    }
                });
            });

        }

        public setupFormSchema(formConfiguration:Wars.Domain.Model.Form) {
            let formPropertiesToOrphan = Enumerable.from(formConfiguration.formSchema.properties)
                .where(p => Enumerable.from(formConfiguration.mySteps)
                    .all(s => p.typeSchema == null || s.objectSchema_id !== p.typeSchema.id))
                .toArray();

            formPropertiesToOrphan.forEach(p => {
                p.parentObjectSchema = null;
                p.objectSchema_id = null;
            });

            let formSchema: Wars.Domain.Model.ObjectSchema = formConfiguration.formSchema;
            formConfiguration.mySteps.forEach(step => {

                let stepParentSchemaProperty = Enumerable.from(formConfiguration.formSchema.properties).singleOrDefault(p => step.objectSchema_id === p.typeSchema.id);
                step.objectSchema.parentProperty = stepParentSchemaProperty;

                if (!stepParentSchemaProperty) {
                    stepParentSchemaProperty = this.dataSourceService.createNewSchemaProperty();

                    stepParentSchemaProperty.name = !step.objectSchema.name || step.objectSchema.name === "" ? "Default" : step.objectSchema.name;
                    step.objectSchema.name = stepParentSchemaProperty.name;
                    stepParentSchemaProperty.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Object;
                    stepParentSchemaProperty.typeSchema = step.objectSchema;
                    stepParentSchemaProperty.parentObjectSchema = formConfiguration.formSchema;

                    formConfiguration.formSchema.properties.push(stepParentSchemaProperty);
                }

                let stepPropertiesToOrphan = Enumerable.from(step.objectSchema.properties)
                    .where(p => Enumerable.from(step.formSections)
                        .all(s => !p.typeSchema || s.objectSchema_id !== p.typeSchema.id))
                    .toArray();

                stepPropertiesToOrphan.forEach(p => {
                    p.parentObjectSchema = null;
                    p.objectSchema_id = null;
                });

                step.formSections.forEach(formSection => {
                    let parentStepProperty = Enumerable.from(step.objectSchema.properties).singleOrDefault(p =>
                        !formSection.objectSchema || p.type_id === formSection.objectSchema.id);

                    formSection.objectSchema.parentProperty = parentStepProperty;

                    if (!parentStepProperty) {
                        parentStepProperty = this.dataSourceService.createNewSchemaProperty();

                        parentStepProperty.name = !formSection.objectSchema.name || formSection.objectSchema.name === "" ? "Default" : formSection.objectSchema.name;
                        formSection.objectSchema.name = parentStepProperty.name;
                        parentStepProperty.typeSchema = formSection.objectSchema;
                        parentStepProperty.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Object;
                        parentStepProperty.parentObjectSchema =step.objectSchema;

                        step.objectSchema.properties.push(parentStepProperty);
                    }

                    formSection.fields.forEach(field => {
                        formSection.objectSchema.properties.push(field.schemaProperty);
                    });
                });


            });
        }

        public getFormWithSection(processConfigurationId: string): ng.IPromise<Wars.Domain.Model.Form[]> {
            const query = this.breezeModule.EntityQuery
                .from("Forms")
                .where("processConfiguration_id", "==", processConfigurationId)
                .expand('myManageSections');

            return <any>(this.executeQuery(query));
        }

        createAssigmentConfiguration(): Wars.Domain.Model.AssignmentConfiguration {
            return this.createNewEntity<Wars.Domain.Model.AssignmentConfiguration>("AssignmentConfiguration");
        }

        public performFormChangeUpdates(dto: Wars.Domain.Model.Dtos.FormChangeDto): ng.IPromise<boolean> {
            var handlerUrl = "api/FormChange/PerformFormChangeUpdates";
            var params = dto;
            var result: ng.IPromise<any> = this.$http.post(handlerUrl, params)
                .then((response: any): ng.IPromise<any> => this.handlerResponded(response, params));

            return result;
        }

        public updateFieldType(schemaPropertyId: string, variableType: Wars.Domain.Model.Codes.Enums.VariableType): ng.IPromise<boolean> {
            var handlerUrl = 'api/FormChange/' + schemaPropertyId + '/UpdateFieldType/' + variableType;
            var result: ng.IPromise<any> = this.$http.post(handlerUrl, {})
                .then((response: any): ng.IPromise<any> => this.handlerResponded(response, {}));

            return result;
        }
    }
}

warsApp.registerService('FormService', ['breeze', '$q', '$http', 'ModalService',
    'formSectionService','securityMatrixService','dataSourceService']);